export const TIME_STAMP = {
  JUST_NOW: __('Just now'),
  MINUTE_AGO: __('Minute ago'),
  AN_HOUR_AGO: __('An hour ago')
};
export const BROWSER_TYPE = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  FIREFOX: 'Firefox',
  EDGE: 'Edg'
};
export const DEFAULT_DISABLED_FIELDS_COUNT = 1;
export const DEFAULT_FIELD_WRAPPER_IDENTIFIER = '.ticketFormField';